import React from 'react';
import { CheckIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
const trustItems = ['Print-ready PDF', 'Instant download', 'Lifetime access', '30-day guarantee'];
export function FinalCTASection() {
  return <section aria-labelledby="final-cta-title" className="w-full bg-pine px-5 py-20 text-center md:py-28" data-id="element-68" data-mp="3s0bo6uw34dgx">
      <Reveal className="mx-auto max-w-3xl" data-id="element-69" data-mp="2zdijk1fkqu1n">
        <h2 id="final-cta-title" className="mx-auto max-w-2xl text-3xl font-extrabold leading-[1.12] tracking-tight text-white md:text-[2.75rem]" data-id="element-70" data-mp="2zejy4fvstyo4">
          Ready to Walk onto the Field Ready for <span className="italic text-amber" data-id="element-71" data-mp="39a3qwtf2gh8n">Every Session</span>?
        </h2>
        <p className="mx-auto mt-5 max-w-xl leading-relaxed text-white/75" data-id="element-72" data-mp="3e3gauq8svzv2">
          Stop improvising on the drive over. Print your season once and coach with confidence all the way from U8 to
          U17.
        </p>
        <div className="mt-10 flex justify-center" data-id="element-73" data-mp="2lkj582rj35vo">
          <CTAButton className="w-full max-w-md" data-id="element-74" data-mp="26vk6hn59i42k" />
        </div>
        <ul className="mt-7 flex flex-wrap items-center justify-center gap-x-6 gap-y-2.5" data-id="element-75" data-mp="26x3llaf6m92r">
          {trustItems.map(item => <li key={item} className="inline-flex items-center gap-1.5 text-xs font-medium text-white/75" data-id="element-76" data-mp="1x4xus40o1xp5">
              <CheckIcon className="h-3.5 w-3.5 shrink-0 text-turquoise" strokeWidth={3} aria-hidden="true" data-id="element-77" data-mp="1s6nyfq37gr1y" />
              {item}
            </li>)}
        </ul>
      </Reveal>
    </section>;
}